import { atom } from "recoil";

export interface IDelayTimeToEnd {
  min: number;
  sec: number;
}

export const DelayTimeAtom = atom<Date | null>({
  key: "Delay",
  default: null,
});

export const DelayTimeToEndAtom = atom<IDelayTimeToEnd>({
  key: "DelayTimeToEnd",
  default: {
    min: 0,
    sec: 0,
  },
});

export const DelayTimeIsOverAtom = atom<boolean>({
  key: "DelayTimeIsOver",
  default: true,
});
